// extracted by mini-css-extract-plugin
export default {"CallToAction":"CallToAction_CallToAction__-W5di"};